/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CoursesList } from '../../models/courses-list';

export interface ApiStudentItemIdCoursesGet$Params {
  item_id: number;
}

export function apiStudentItemIdCoursesGet(http: HttpClient, rootUrl: string, params: ApiStudentItemIdCoursesGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CoursesList>> {
  const rb = new RequestBuilder(rootUrl, apiStudentItemIdCoursesGet.PATH, 'get');
  if (params) {
    rb.path('item_id', params.item_id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CoursesList>;
    })
  );
}

apiStudentItemIdCoursesGet.PATH = '/api/student/{item_id}/courses';
